import React from 'react'
import ContactForm from '../ContactFrom/ContactForm'
import { SocialIcon } from 'react-social-icons';


const ContactArea = (props) => {
    return (
        <section className={`wpo-contact-section section-padding ${props.contactClass}`} id='contact'>
            <div className="container">
                <div className="wpo-contact-section-wrapper">
                    <div className="row">
                        <div className="col col-xl-5 col-lg-6">
                            <div className="contact-info-wrap">
                                <div className="contact-info-title">
                                    <h3>İletişim Bilgilerim</h3>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className='fi flaticon-house'></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Konum</h4>
                                        <p>Adana, Türkiye</p>
                                    </div>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className='fi flaticon-email'></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Mail Adresim</h4>
                                        <p>janberk.altayy@gmail.com</p>
                                    </div>
                                </div>
                                <div className="contact-info-item">

                                    <div className="contact-info-text" >
                                        <h4>Sosyal Medya Hesaplarım</h4>
                                        <SocialIcon
                                            url="https://www.instagram.com/janberkaltay/"
                                            target="_blank"
                                            style={{ marginRight: 12 }}
                                        />

                                        <SocialIcon
                                            url="https://www.linkedin.com/in/janberkaltay/"
                                            target="_blank"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-xl-7 col-lg-6 col-md-12 col-12">
                            <ContactForm btnClass={props.btnClass} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactArea;